import PropTypes from 'prop-types';

const onOff = ['on', 'off'];

export default {
  updatePriv: PropTypes.oneOf(onOff).isRequired,
  grantPriv: PropTypes.oneOf(onOff).isRequired,
  executePriv: PropTypes.oneOf(onOff).isRequired,
};
